var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9995 1.08154C33.5964 1.08163 42.9926 10.4098 42.9927 21.9106C42.9927 33.4116 33.5964 42.7397 21.9995 42.7397C10.4025 42.7397 1.00635 33.4116 1.00635 21.9106C1.00644 10.4097 10.4026 1.08154 21.9995 1.08154Z",
    stroke: "white",
    strokeWidth: 0.763387
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4214 20.3952L22.9872 18.9719C22.6891 18.6761 22.6891 18.1965 22.9872 17.9006L24.0668 16.8293C24.3649 16.5335 24.8483 16.5335 25.1464 16.8293L29.1871 20.839C29.4733 21.1231 29.6342 21.5084 29.6342 21.9102C29.6342 22.312 29.4733 22.6973 29.1871 22.9814L25.1464 26.9911C24.8483 27.2869 24.3649 27.2869 24.0668 26.9911L22.9872 25.9198C22.6891 25.6239 22.6891 25.1443 22.9872 24.8485L24.4213 23.4253L16.3511 23.4253C15.9235 23.4253 15.7098 23.4253 15.5465 23.3428C15.4028 23.2702 15.286 23.1543 15.2128 23.0117C15.1296 22.8497 15.1296 22.6375 15.1296 22.2133V21.6073C15.1296 21.183 15.1296 20.9709 15.2128 20.8088C15.286 20.6663 15.4028 20.5504 15.5465 20.4778C15.7098 20.3952 15.9235 20.3952 16.3511 20.3952L24.4214 20.3952Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundBackIcon);
export default __webpack_public_path__ + "static/media/roundBackIcon.1ca3089b5c21237ec8072055c698e7db.svg";
export { ForwardRef as ReactComponent };